module.exports = __webpack_public_path__ + "static/ecd_logo-09000e2eb6abed3d95a759f61d354f62.png";